module.exports = __webpack_public_path__ + "img/catalog.3c570bc2.svg";